/**
 * Recursively converts a plain object into FormData using bracket notation
 *
 * - File values are appended as-is.
 * - null/undefined values are skipped.
 * - boolean values are appended as 1 or 0.
 */
export function toFormData(
  data: Record<string, unknown>,
  fd = new FormData(),
  parentKey = '',
): FormData {
  for (const [key, value] of Object.entries(data)) {
    const formKey = parentKey ? `${parentKey}[${key}]` : key

    if (value === null || value === undefined) continue

    if (value instanceof File) {
      fd.append(formKey, value)
    } else if (Array.isArray(value)) {
      value.forEach((item, i) => {
        const arrayKey = `${formKey}[${i}]`
        if (typeof item === 'object' && item !== null) {
          toFormData(item as Record<string, unknown>, fd, arrayKey)
        } else if (typeof item === 'boolean') {
          fd.append(arrayKey, item ? '1' : '0')
        } else {
          fd.append(arrayKey, String(item))
        }
      })
    } else if (typeof value === 'object') {
      toFormData(value as Record<string, unknown>, fd, formKey)
    } else if (typeof value === 'boolean') {
      fd.append(formKey, value ? '1' : '0')
    } else {
      fd.append(formKey, String(value))
    }
  }

  return fd
}
